import { render, staticRenderFns } from "./customerFeedback.vue?vue&type=template&id=2840d7bc&scoped=true"
import script from "./customerFeedback.vue?vue&type=script&lang=js"
export * from "./customerFeedback.vue?vue&type=script&lang=js"
import style0 from "./customerFeedback.vue?vue&type=style&index=0&id=2840d7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840d7bc",
  null
  
)

export default component.exports